<form [formGroup]="form" style="margin-top: 10px;">
    <div style="display: inline-flex;">
        <label style="width: 20%;">{{"newOrder.equipment.searchInput.placeholder" | translate}}</label>
        <input class="form-control parameter-input" formControlName="searchAccessoryInput" style="padding-right: 35px;"/>
        <button (click)="clearSearchAccessoryInput()" class="clear-button"><img src="assets/img/icons/delete2.svg" style="width: 30px;"></button>
    </div>
</form>

<div class="d-flex headers">
    <div *ngIf="ordering" style="margin-left: 5%; width: 765px; font-size: 20px; font-weight: 700;"><span (click)="sortByName()" style="cursor: pointer;">{{"newOrder.equipment.columnNames.name" | translate}}</span><fa-icon style="margin-left: 5px;" [icon]="getSortIcon()"></fa-icon></div>
    <div *ngIf="ordering" style="width: 80px; font-size: 20px; font-weight: 700;"><span>{{"newOrder.equipment.columnNames.price" | translate}}</span></div>
    <div *ngIf="ordering" style="width: 75px; font-size: 20px; font-weight: 700;"><span>{{"newOrder.equipment.columnNames.count" | translate}}</span></div>
    <div *ngIf="ordering" style="font-size: 20px; font-weight: 700;"><span>{{"newOrder.equipment.columnNames.info" | translate}}</span></div>
    <div *ngIf="!ordering" style="margin-left: 5%; width: 580px; font-size: 20px; font-weight: 700;"><span (click)="sortByName()" style="cursor: pointer;">{{"newOrder.equipment.columnNames.name" | translate}}</span><fa-icon style="margin-left: 5px;" [icon]="getSortIcon()"></fa-icon></div>
    <div *ngIf="!ordering" style="font-size: 20px; font-weight: 700; width: 300px;"><span>{{"admin.electronicOrdering.title" | translate}}</span></div>
    <div *ngIf="!ordering" style="font-size: 20px; font-weight: 700;"><span>{{"admin.accounts.actions" | translate}}</span></div>
</div>
<div style="height: 400px; overflow-y: scroll;">
    <div *ngFor="let item of filteredAccessoryItems | async" [value]="item" class="d-flex item">
        <div class="img">
            <img src="{{item.imageUrl}}">
        </div>
        <div *ngIf="ordering" class="d-flex name">
            {{item.name}}
        </div>
        <div *ngIf="ordering" class="d-flex price-info">
            <div *ngIf="!item.electronicOrdering" class="exclamation-mark">
              {{"newOrder.equipment.available" | translate}}
            </div>
            <div class="right-shift">
              <div *ngIf="item.priceInfo.length > 1" class="discount" matTooltip="{{getDiscountHint(item.priceInfo).join('\n')}}" matTooltipPosition="below" matTooltipClass="allow-break">
                  {{"newOrder.equipment.columnNames.discount" | translate}}
              </div>
            </div>
        </div>
        <div *ngIf="ordering" class="d-flex price">
           <div class="right-shift">{{item.price}}&nbsp;€</div>
        </div>
        <div *ngIf="ordering" class="count d-flex">
            <input class="form-control" [(ngModel)]="item.units" type="number" min="1" max="999">
        </div>
        <div *ngIf="ordering" class="info d-flex">
            <img src="assets/img/icons/info.svg" [matTooltip]="item.description" matTooltipPosition="above">
        </div>
        <div *ngIf="ordering" class="cart d-flex">
            <img src="assets/img/icons/add-shopping-cart.svg" (click)="addAccessoryItem(item, item.units)"/>
        </div>
        <div *ngIf="!ordering" class="d-flex ordering-name">
          <div style="margin-right: 20px">
            {{item.name}}
          </div>
        </div>
        <div *ngIf="!ordering" class="ordering d-flex">
          {{item.electronicOrdering}}
        </div>
        <div *ngIf="!ordering" class="action d-flex">
          <button mat-flat-button color="primary" class="update-button" (click)="switchOrdering(item, item.id)">
            {{"newOrder.buttons.switch"| translate}}
          </button>
        </div>
    </div>
</div>
